import { render, staticRenderFns } from "./PcgReinitialisation.vue?vue&type=template&id=728a845f&"
import script from "./PcgReinitialisation.vue?vue&type=script&lang=js&"
export * from "./PcgReinitialisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports